<template>
    <div>
        <div class="breadcrumb">
            <h1 style="color: #AC8400;">Company Details</h1>
        </div>

        <!-- Breadcrumbs -->
        <div style="padding: 10px; background-color: #F2F2F2">
            <router-link to="/dashboard">Dashboard</router-link>
            /
            <b>Loyalty Point System</b>
            /
            <router-link :to="{name: 'vendor-view'}">Vendor List</router-link>
            /
            <router-link :to="{name: 'company-request-update', params: { id: id }}">Company List</router-link>
            /
            <b>Update</b>
        </div>
        <!-- End of breadcrumbs -->

        <div class="separator-breadcrumb border-top"></div>

        <div class="row mb-4">
            <div class="col-md-12 mb-4">
                <!-- Card -->
                <div class="card text-left">
                    <div class="card-body">
                        <h4 class="card-title mb-3">
                            <b>Company Details</b>
                        </h4>

                        <!-- <p>Fill in the information</p> -->

                            <div class = "form-group">
                                <label>Company Name</label>
                                <input v-model="vendor.name" class="form-control" disabled>
                            </div>

                            <div class = "form-group">
                                <label>Banner Description</label>
                                <textarea class="form-control" v-model="vendor.description" placeholder="Enter Banner Description" disabled>
                                </textarea>
                            </div>

                            <div class = "form-group">
                                <label>Remarks</label>
                                <textarea class="form-control" v-model="vendor.remarks" placeholder="Enter Remarks">
                                </textarea>
                            </div>

                            <!-- <div class = "form-group">
                                <label>Upload Image </label> <br>
                                <small class="text-danger"> (Recommended size for image 468 x 60px)</small>
                                <input type="file" id="banner_link" ref="banner_link" v-on:change="handleFileUpload()" class = "form-control">
                                <br>
                            </div> -->

							<div class = "form-group" style="margin: auto">
								<img :src="src">
							</div>
                                
                            <div class="row" style="margin-top: 30px;">
                                <div class="col-12 text-center">
                                    <span class="col-3"></span>
                                    <button class="btn btn-lg btn-success  col-2" @click="approve()">Approve</button>
                                    <span class="col-2"></span>
                                    <button class="btn btn-lg btn-danger col-2" @click="resubmit(vendor.id)">Request Resubmit</button>
                                    <span class="col-3"></span>
                                </div>
                            </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

export default {
	name: "banner_new",

	data(){
		return{
			vendor: [],
			pending_banner_link: null,
			banner_link:"",
      src: "",
      id: ''
		}
	},

	methods:{
		loadVendor() {
			let token = localStorage.getItem("token");
			let user = JSON.parse(localStorage.getItem("user"));
			let id = this.$route.params.id

			// check if has token
			if (token !== null) {
				token = JSON.parse(token);
				token = token.access_token;

				axios
				.get(axios.lpsURL + "/vendor/getOne/" + id, {
					headers: {
					Authorization: "Bearer " + token
					}
				})
				.then(res => {
					this.vendor = res.data;


					if(this.vendor.pending_banner_link != null){
						this.pending_banner_link = this.vendor.pending_banner_link
						this.loadPendingImage(token, id)
					}

				})
			}
		},

		loadPendingImage(token, id){
			axios.get(axios.lpsURL + "/vendor/banner/" + id + "/show/pending", 
			{
				headers: {
				Authorization: "Bearer " + token
				},
				responseType: 'blob'
			})
			.then(response =>{
				let reader = new FileReader();
				reader.readAsDataURL(response.data); 
				reader.onload = () => {
				this.src = reader.result
				}
			})
        },
        
        approve(){
            let token = localStorage.getItem("token");
            let vendor_id = this.$route.params.id;

            // check if has token
            if (token !== null) {
                token = JSON.parse(token);
                token = token.access_token;
            }
            
            swal({
              icon: 'warning',
              text: 'Are you sure?',
              buttons: ['Cancel', 'Yes']
            }).then((confirm) => {
              if(!confirm) {
                return;
              }
              axios.post(axios.lpsURL + "/vendor/approve/" + vendor_id, 
              {

              },
              {
                  headers: {
                    Authorization: "Bearer " + token
                  }
              })
              .then(res => {
                  swal({
                  title: "Success",
                  icon: "success",
                  text: res.data.message
                  })
                  .then(() => {
                  this.$router.push("/lps/vendor/company/" + vendor_id)
                  })
              })
            })
            
        },

        resubmit(id){
            let token = localStorage.getItem("token");
            let vendor_id = this.$route.params.id;

            // check if has token
                if (token !== null) {
                    token = JSON.parse(token);
                    token = token.access_token;
                }

                swal({
                  icon: 'warning',
                  text: 'Are you sure?',
                  buttons: ['Cancel', 'Yes']
                }).then((confirm) => {
                  if(!confirm) {
                    return;
                  }
                  axios.post(axios.lpsURL + "/vendor/reject/" + vendor_id, 
                  {
                      remarks: this.vendor.remarks
                  },
                  {
                      headers: {
                      Authorization: "Bearer " + token
                      }
                  })
                  .then(res => {
                      swal({
                      title: "Success",
                      icon: "success",
                      text: res.data.message
                      })
                      .then(() => {
                      this.$router.push("/lps/vendor/company/" + vendor_id)
                      })
                  })
                })

            }

	},


	mounted(){
    this.loadVendor()
    this.id = this.$route.params.id;
	}
}
</script>

